export default __webpack_public_path__ + "static/Muhammad_Umair-b982a61349953bc958e745eaeab213be.jpg";